var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.645,2.92,13.088.363a1.232,1.232,0,0,0-1.74,0L9,2.708l-.03.028-.029.03L.777,10.935a1.275,1.275,0,0,0-.361.733l-.4,3.066a1.122,1.122,0,0,0,1.259,1.259l3.066-.4a1.274,1.274,0,0,0,.733-.361L13.266,7.04l.006-.006.006-.006L15.645,4.66A1.232,1.232,0,0,0,15.645,2.92ZM4.039,14.056l-2.4.314.314-2.4L9.527,4.395l2.087,2.087Zm8.68-8.68L10.632,3.289,12.218,1.7,14.305,3.79Z",
    transform: "translate(-0.005 -0.004)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.5365575b85c9acb54be5e5fb44e1ed78.svg";
export { ForwardRef as ReactComponent };